import { UserManagerSettings, WebStorageStateStore } from "oidc-client";

export const defaultUserManagerSettings: UserManagerSettings = {
  automaticSilentRenew: false,
  revokeAccessTokenOnSignout: true,
  stopCheckSessionOnError: true,
  monitorSession: false,
  includeIdTokenInSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage })
};

export const oidcClientId = "Cadmakers.Core.Feedback-auth-code";
